export const TRANSACTION_APIS = {
  validate_refunds: "payments/validate/refunds",
  initiate_refunds: "payments/initiate/refunds",
  status_refund_order: "payments/refunds/order/status",
  refund_history_retry: "payments/refunds/retry",
  e_invoice_list: "payments/exly/einvoice/list",
  e_invoice_retry: "payments/einvoice/retry",
  e_invoice_summary: "payments/einvoice/summary",
};
